import request from '@/plugins/axios'

/** S 通知设置 **/
// 通知列表
export const apiNoticeLists = (params: any) => request.get('/notice.system_message/lists', {params})

// 添加通知
/**
 * 添加系统通知消息的API接口函数
 * @param params - 包含通知消息相关参数的对象，具体结构取决于后端API要求
 * @returns 返回一个Promise，解析为API请求的响应结果
 */
export const apiNoticeAdd = (params: any) => request.post('/notice.system_message/add', params)
export const apiNoticeEdit = (params: any) => request.post('/notice.system_message/edit', params)
/**
 * 发送系统通知的API接口函数
 * @param params - 包含通知相关参数的对象
 * @returns 返回请求发送后的Promise结果
 */
export const apiNoticeSend = (data: any) => request.post('/notice.system_message/send', data)
/**
 * 删除系统通知的API接口函数
 * @param params - 包含删除通知所需参数的对象
 * @returns 返回一个Promise，通过request.post发送删除请求
 */
export const apiNoticeDelete = (data: any) => request.post('/notice.system_message/delete', data)
/**
 * 获取通知详情的API函数
 * @param params - 包含通知详情请求参数的对象
 * @returns 返回一个Promise，包含请求的响应数据
 */
export const apiNoticeDetail = (params: any) => request.get('/notice.system_message/detail', {params})
